import { result } from 'underscore';
import { buildInValidationRulesImplementation } from '../util';

class DataModel {
  constructor({
    id, data, validationRules, validateCallBack,
    isValid = true, errorMessages = [], type,
  }) {
    this.data = data;
    this.id = id;
    this.validationRules = validationRules;
    this.validateCallBack = validateCallBack;
    this.isValid = isValid;
    this.errorMessages = errorMessages;
    this.subscribeList = {};
    this.type = type;
  }
}

DataModel.prototype.getValidationRules = function getValidationRules() {
  // eslint-disable-next-line prefer-destructuring
  const validationRules = this.validationRules;
  let validationRulesImps = null;
  if (validationRules) {
    validationRulesImps = validationRules.map(({ rule, errorMessage }) => {
      if (typeof rule === 'string') {
        if (buildInValidationRulesImplementation[rule]) {
          return {
            validationFunction: buildInValidationRulesImplementation[rule],
            errorMessage,
          };
        }

        return null;
      }
      return {
        validationFunction: rule,
        errorMessage,
      };
    });
  }

  return validationRulesImps;
};

DataModel.prototype.validate = function validate(validateOptions = {}) {
  const value = this.data ? this.data.value : null;
  const type = result(this, 'type');
  const validationRulesImps = this.getValidationRules();
  const errorMessages = [];
  let isValid = true;

  if (validationRulesImps !== null) {
    for (let i = 0; i < validationRulesImps.length; i += 1) {
      const item = validationRulesImps[i];
      if (item) {
        const { errorMessage, validationFunction } = item;
        if (!validationFunction(value, this.data, type, validateOptions)) {
          isValid = false;
          errorMessages.push(errorMessage);
          break;
        }
      }
    }
  }

  // eslint-disable-next-line no-unused-expressions
  this.validateCallBack && this.validateCallBack({
    errorMessages,
  });

  this.isValid = isValid;
  this.errorMessages = errorMessages;
};

DataModel.prototype.subscribe = function subscribe(event, fn) {
  if (this.subscribeList[event] === undefined) {
    this.subscribeList[event] = [fn];
  } else {
    this.subscribeList[event].push(fn);
  }
};

DataModel.prototype.trigger = function trigger(event, arg = null) {
  if (this.subscribeList[event] !== undefined) {
    this.subscribeList[event].forEach(fn => fn.apply(this, [this.data, arg]));
  }
};

export {
  DataModel
};
